// removed by extract-text-webpack-plugin
module.exports = {"base":"BattleRoomsSchedule_base--2GGvb","isAllModes":"BattleRoomsSchedule_isAllModes--2Pb4k","title":"BattleRoomsSchedule_title--uWG45","scheduleWrapper":"BattleRoomsSchedule_scheduleWrapper--1ct6F","scheduleTime":"BattleRoomsSchedule_scheduleTime--3Ew-h"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/BattleRoomsSchedule/BattleRoomsSchedule.scss
// module id = 440
// module chunks = 11 12